import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import cutthroatLogo from '../images/CUTTHROAT logo.png';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { title: 'PLAY NOW', path: '/' },
    { title: 'HOW TO PLAY', path: '/how-to-play' },
    { title: 'PRIVACY POLICY', path: '/privacy-policy' },
    { title: 'TERMS OF SERVICE', path: '/terms-of-service' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 pointer-events-none">
      <div className="flex justify-between items-start pt-6 px-4 md:px-12">
        {/* Logo Block */}
        <Link to="/" className="pointer-events-auto origin-top-left group">
          <img
            src={cutthroatLogo}
            alt="CUTTHROAT Logo"
            className="h-16 w-auto object-contain transition-transform duration-200 group-hover:scale-110"
          />
        </Link>

        {/* Desktop Nav Links (Skewed) */}
        <div className="hidden md:flex space-x-6 pointer-events-auto">
          {navLinks.map((link, i) => (
            <Link key={link.title} to={link.path} className="relative group">
              <div className={`${i % 2 === 0 ? 'bg-white text-black border-black' : 'bg-black text-white border-white'} px-6 py-2 transform -skew-x-12 border-2 transition-all duration-300 group-hover:bg-gradient-to-r group-hover:from-yellow-400 group-hover:to-yellow-600 group-hover:text-white group-hover:translate-y-1`}>
                <span className="font-bold tracking-tight text-lg transform skew-x-12 inline-block whitespace-nowrap">{link.title}</span>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile Menu Toggle Icon */}
        <div 
          onClick={toggleMenu}
          className="md:hidden pointer-events-auto bg-yellow-400 text-black p-3 border-4 border-black transform -rotate-3 cursor-pointer hover:bg-white transition-colors box-shadow-hard"
        >
          <iconify-icon icon={isOpen ? "solar:close-square-linear" : "solar:hamburger-menu-linear"} width="32"></iconify-icon>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-black z-40 transition-transform duration-500 pointer-events-auto ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        {/* Background Halftone Overlay */}
        <div className="absolute inset-0 bg-halftone opacity-20 pointer-events-none"></div>
        
        <div className="relative h-full flex flex-col justify-center items-center p-8 space-y-6">
          {navLinks.map((link, i) => (
            <Link 
              key={link.title} 
              to={link.path} 
              onClick={toggleMenu}
              className="w-full max-w-sm"
            >
              <div className={`w-full ${i % 2 === 0 ? 'bg-white text-black border-yellow-400 shadow-[8px_8px_0px_#ef4444]' : 'bg-yellow-400 text-black border-black shadow-[8px_8px_0px_#fff]'} p-6 border-4 transform ${i % 2 === 0 ? 'rotate-2' : '-rotate-2'} hover:rotate-0 transition-transform`}>
                <span className="font-anton text-4xl uppercase tracking-tighter block text-center italic">{link.title}</span>
              </div>
            </Link>
          ))}
          
          {/* Close hint */}
          <p className="font-marker text-yellow-400 text-xl pt-8 transform -rotate-1">CLOSE MENU // RETURN TO ARENA</p>
        </div>
      </div>
    </nav>
  );
};
